<ion-grid class="ion-no-padding">
  <form [formGroup]="userForm" (ngSubmit)="updateUser()">
    <ion-row class="ion-justify-content-center">
      <ion-col
        size="12"
        size-md="10"
        size-lg="8"
        class="ion-no-margin ion-no-padding"
      >
        <ion-row class="ion-align-items-center ion-padding-top">
          <ion-col size="12" size-lg="4" class="ion-hide-down">
            <ion-label class="align-label">{{
              'profile_firstname' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="12" size-lg="8">
            <ion-input
              fill="outline"
              formControlName="firstname"
              [label]="'profile_firstname' | translate"
              label-placement="stacked"
              [class.is-invalid]="
                formHelper.isFieldValidCss('firstname', isFormSubmitAttempted())
              "
            >
            </ion-input>
          </ion-col>
        </ion-row>

        <ion-row class="ion-align-items-center">
          <ion-col size="12" size-lg="4" class="ion-hide-down">
            <ion-label class="align-label">{{
              'profile_lastname' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="12" size-lg="8">
            <ion-input
              fill="outline"
              formControlName="lastname"
              [label]="'profile_lastname' | translate"
              label-placement="stacked"
              [class.is-invalid]="
                formHelper.isFieldValidCss('lastname', isFormSubmitAttempted())
              "
            >
            </ion-input>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12" offset-lg="4">
            <ion-item lines="none" class="transparent-item">
              <ion-checkbox (ionChange)="updateIsCompany($event)">
                {{ 'profile_isCompany' | translate }}
              </ion-checkbox>
            </ion-item>
          </ion-col>
        </ion-row>

        @if (isCompany()) {
          <ion-row class="ion-align-items-center">
            <ion-col size="12" size-lg="4" class="ion-hide-down">
              <ion-label class="align-label">{{
                'profile_companyname' | translate
              }}</ion-label>
            </ion-col>
            <ion-col size="12" size-lg="8">
              <ion-input
                fill="outline"
                formControlName="companyname"
                label-placement="stacked"
              ></ion-input>
            </ion-col>
          </ion-row>
        }

        <ion-row class="ion-align-items-center">
          <ion-col size="12" size-lg="4" class="ion-hide-down">
            <ion-label class="align-label">{{
              'profile_vatNo' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="12" size-lg="8">
            <acl-vat formControlName="vatno"></acl-vat>
          </ion-col>
        </ion-row>

        @for (field of ['streetNr', 'postalcode', 'city']; track field) {
          <ion-row class="ion-align-items-center">
            <ion-col size="12" size-lg="4" class="ion-hide-down">
              <ion-label class="align-label">{{
                'profile_' + field | translate
              }}</ion-label>
            </ion-col>
            <ion-col size="12" size-lg="8">
              <ion-input
                fill="outline"
                [formControlName]="field"
                [class.is-invalid]="
                  formHelper.isFieldValidCss(field, isFormSubmitAttempted())
                "
              >
              </ion-input>
            </ion-col>
          </ion-row>
        }

        <ion-row class="ion-align-items-center">
          <ion-col size="12" size-lg="4" class="ion-hide-down">
            <ion-label class="align-label">{{
              'profile_language' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="12" size-lg="8">
            <ion-item lines="none" class="custom-selectable-item">
              @if (languageData()) {
                <ion-select formControlName="language">
                  @for (lang of languageData(); track lang.id) {
                    <ion-select-option [value]="lang">
                      {{ lang.name }}
                    </ion-select-option>
                  }
                </ion-select>
              }
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row class="ion-margin-top">
          <ion-col size="12" offset-lg="4">
            <ion-button
              type="submit"
              color="primary"
              [disabled]="!userForm.valid"
              expand="block"
            >
              {{ 'general_update' | translate }}
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </form>
</ion-grid>
